import backIcon from "../assets/images/back.svg"
import {ReactComponent as Edit} from "../assets/images/edit.svg"
import {ReactComponent as Trash} from "../assets/images/trash.svg"
import peeking from "../assets/images/Bunny-peeking.png"
import { a } from "../services/axiosInstance"
import { Link, useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { HOME, UPDATE, DELETE } from "../services/consts"
import Error from "../components/Error"



function Read() {

    const {id} = useParams();
    const [post, setPost] = useState({});
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        async function fetchPosts() {
            try {
                const res = await a.get(`items/detail/${id}`);
                setPost(res.data);
                console.log(res.data)
            } catch (e) {
                setIsError(true);
                console.log(e)
            }
        }
        fetchPosts();
    }, [id]);

    if (isError) {
        return <Error />
    }

    return(
        <div className="block">
            <div className="container">
                <div className="status">
                    <Link to={HOME}>
                        <img className="back" src={backIcon} alt="back" />
                    </Link>
                    <h1 >Reading</h1>
                    <div className="empty"></div>
                </div>
                <p className="description ">
                    <div className="pattern form-control width">
                        {post.content}
                    </div>
                </p>
                <div className="bottom-menu">
                    <Link to={DELETE.substring(0, DELETE.length - 3) + post.id} className="delete">
                    <Trash/>
                    </Link>
                    <Link to={UPDATE.substring(0, UPDATE.length - 3) + post.id} className="edit">
                    <Edit/>
                    </Link>
                    <img className="peek" src={peeking} alt="bunny" />
                </div>
            </div>
        </div>
    );
}

export default Read;